// Copyright (C) 2022 Intel Corporation
//
// SPDX-License-Identifier: MIT
import { connect } from 'react-redux';
import Input from 'antd/lib/input';
import { Col, Row } from 'antd/lib/grid';
import Collapse from 'antd/lib/collapse';

import React, { useState, useEffect } from 'react';

/* eslint no-underscore-dangle: 1 */

let sampleState: any;

interface Props {
    readonly: boolean;
    attrValue: string;
    attrID: number;
    ref: any;
    changeAttribute(attrID: number, value: string): void;
}

function AisBlock({
    attrValue, ref, readonly, changeAttribute, attrID,
}: Props) : JSX.Element {
    let aisData: any[] = [];
    const [input, setInput] = useState(attrValue);
    const [searchClicked, setSearchClicked] = useState(false);
    const [filteredList, setFilteredList] = useState(aisData);

    const sampleSource = sampleState._source;
    if (sampleSource) {
        aisData = sampleSource.ais_window;
        if (!aisData) {
            aisData = [];
        }
    }

    // when ship on ais map is clicked, the ais number will be added to the redux store
    // it will cause this component to rerender and below function will update the mmsi
    useEffect(() => {
        if (attrValue !== input) {
            setInput(attrValue);
        }
    }, [attrValue, input]);

    // live search in the search bar
    const filterBySearch = (event : any): any => {
        const query = event
            .target
            .value
            .toString();
        let updatedList = [...aisData];
        updatedList = updatedList.filter((item) => item.ais_mmsi
            .toString()
            .startsWith(query));
        setFilteredList(updatedList);
        setInput(query);
    };

    const suggestions = (): any => {
        if (searchClicked) {
            // suggestion field
            return (
                <div id='item-list'>
                    <ol className='suggestions'>
                        {filteredList.map((item: any, index: number) => (
                            <li // eslint-disable-line jsx-a11y/no-noninteractive-element-interactions
                                key={index}
                                // onmouseDown because onBlur has higher priority than on onclick.
                                onMouseDown={() => {
                                    setFilteredList([]);
                                    setInput(item.ais_mmsi.toString());
                                    changeAttribute(attrID, item.ais_mmsi.toString());
                                }}
                            >
                                {item.ais_mmsi}
                            </li>
                        ))}
                    </ol>
                </div>
            );
        }
        return <div id='item-list' />;
    };

    return (
        <Col span={16}>
            <Input
                ref={ref}
                size='small'
                disabled={readonly}
                onChange={(event: any) : void => {
                    setSearchClicked(true);
                    filterBySearch(event);
                    changeAttribute(attrID, event.target.value);
                }}
                onBlur={() => setSearchClicked(false)}
                value={input}
                className='cvat-object-item-text-attribute'
            />
            {suggestions()}
            <Row>
                <Collapse className='cvat-objects-sidebar-state-item-collapse'>
                    <Collapse.Panel header={<span style={{ fontSize: '11px' }}>AIS Details</span>} key='details'>
                        {aisData.filter((item) => item.ais_mmsi === parseInt(input, 10)).map((item) => (
                            <ul>
                                <li>{item.ais_mmsi}</li>
                                <li>{item.ais_name}</li>
                                <li>{item.ais_shiptype_str}</li>
                                <li>{item.ais_destination}</li>
                            </ul>
                        ))}
                    </Collapse.Panel>
                </Collapse>
            </Row>
        </Col>

    );
}

function mapStateToProps(state : any): any {
    const annotationData = state.annotation.annotations.states;
    sampleState = state.sample.data;
    return annotationData;
}

export default connect(mapStateToProps)(React.memo(AisBlock));
